import { render, staticRenderFns } from "./class-detail.vue?vue&type=template&id=25ebace3&scoped=true&"
import script from "./class-detail.vue?vue&type=script&lang=js&"
export * from "./class-detail.vue?vue&type=script&lang=js&"
import style0 from "./class-detail.vue?vue&type=style&index=0&id=25ebace3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ebace3",
  null
  
)

export default component.exports